<template>
  <div class="row">
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
      <h6 class="upper-text worksansr">Período de validação da prescrição:</h6>
    </div>
    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
      <h6 class="upper-text worksansr">DATA DE INÍCIO</h6>
      <input v-model="start_date" type="date" class="form-control" />
    </div>
    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
      <h6 class="upper-text worksansr">DATA DE TÉRMINO</h6>
      <input v-model="end_date" type="date" class="form-control" />
    </div>
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
      <h6>RESIDENTE:</h6>
      <input
        disabled
        type="text"
        v-model="resident_name"
        class="form-control"
      />
    </div>
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
      <ErrorsMessages :errors="errors" />
    </div>
    <div
      class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 check-text-right"
    >
      <v-btn :disabled="loading" @click="update" class="btn-notcertified">
        <i class="fas fa-check mr-2 text-twenty"></i>
        FINALIZAR MANUAL
        {{ loading ? "CARREGANDO" : "COM ASSINATURA ELETRÔNICA" }}
      </v-btn>
    </div>
  </div>
</template>

<script>
import ErrorsMessages from "../../../templates/Components/ErrorsMessages";

import api from "../../../services/api";

import { userData } from "../../../lib/functions";

import { formatDateToUs } from "../../../lib/format";

import toast from "../../../lib/ToastNotification";

export default {
  name: "Medicine",
  components: {
    ErrorsMessages,
  },
  props: {
    id: [String, Number],
    resident_name: String,
    resident_id: [String, Number],
  },
  data() {
    return {
      rest_home_id: "",
      loading: false,
      user_id: null,
      start_date: "",
      tmp_start_date: "",
      end_date: "",
      tmp_end_date: "",
      errors: [],
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    formatDateToUs,
    async retrieve() {
      let { user } = userData();

      this.rest_home_id = user.rest_home_id;
      this.user_id = user.id;

      let { start_date, end_date } = this.$attrs;

      this.start_date = formatDateToUs(start_date);
      this.tmp_start_date = formatDateToUs(start_date);
      this.end_date = formatDateToUs(end_date);
      this.tmp_end_date = formatDateToUs(end_date);
    },
    async update() {
      try {
        this.loading = true;

        let {
          id,
          user_id,
          start_date,
          tmp_start_date,
          end_date,
          tmp_end_date,
        } = this;

        if (start_date == tmp_start_date && end_date == tmp_end_date) {
          this.loading = false;
          this.$emit("cancel");
          return;
        }

        let params = {
          id,
          user_id,
          start_date,
          end_date,
        };

        const response = await api.put(
          "/rest-home/group-prescription-medicine",
          params
        );

        const { error, errors, message } = response.data;

        if (!error) {
          toast(message, "success");
          this.$emit("update", "paginate");
          this.errors = [];
        } else {
          this.errors = errors;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
